import { ComponentType } from 'react';
import { shallowEqual } from 'react-redux';
import { connectMediaStore, useMMSelector } from './withOwnReduxStore';
import { getGruser } from '../selectors';
import {
  getCanCreateGroupGalleryFolder,
  getCanRearrangeGroupGalleryFolders,
} from '../../utils/groupPrivs';

export type WithGlobalPrivsProps = {
  canRearrangeGalleryFolders: boolean;
  canCreateGalleryFolder: boolean;
};

export const useGlobalPrivs = (): WithGlobalPrivsProps =>
  useMMSelector(state => {
    const gruser = getGruser(state);
    return {
      canRearrangeGalleryFolders:
        !gruser?.isGroup ||
        getCanRearrangeGroupGalleryFolders(gruser.extendedGroup),
      canCreateGalleryFolder:
        !gruser?.isGroup ||
        getCanCreateGroupGalleryFolder(gruser.extendedGroup),
    };
  }, shallowEqual);

export default <TProps>(
  component: ComponentType<TProps>
): ComponentType<TProps> =>
  connectMediaStore(state => {
    const gruser = getGruser(state);
    return {
      canRearrangeGalleryFolders:
        !gruser?.isGroup ||
        getCanRearrangeGroupGalleryFolders(gruser.extendedGroup),
      canCreateGalleryFolder:
        !gruser?.isGroup ||
        getCanCreateGroupGalleryFolder(gruser.extendedGroup),
    };
  })(component as ComponentType<any>); // redux is a bit dumb with generics
